import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/main.css";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);